import { useProjectGroupSummary } from '@/features/project/_hooks/project';
import { ProjectSummary } from '@/features/project/projects/_components/ProjectSummary';
import { useId } from '@/hooks';
import type { FC } from 'react';

export const GroupInProjectsSummary: FC = () => {
  const { id } = useId();
  const groupSummary = useProjectGroupSummary({ id });
  if (!groupSummary.data) {
    return null;
  }
  return <ProjectSummary aggregationSummary={groupSummary.data?.summary} />;
};
